import Component from '../../../shared/component';

export default class AvatarBuilderError extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
  }

  displayError() {
    this.$element.show();
  }

  hideError() {
    this.$element.hide();
  }
}
